import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  PageContent,
  Container,
  Pagination,
  FiltersControls,
  BoxList,
  Spinner,
  Alerts,
} from 'components';
import {
  loadMaCoursesCreator,
  setMaCoursesPageCreator,
  setMaCoursesPerPageCreator,
} from 'store/actionsCreators';
import { connect } from 'react-redux';
import { globalPropTypes, isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';

const Canceled = ({ loading, loadList, setPage, setPerPage, list }) => {
  const { t } = useTranslation();
  const { items, page, pages, perPage } = list;

  useEffect(() => {
    setPage(1);
    loadList();
  }, [perPage]);

  return (
    <PageContent>
      <Container>
        {loading ? <Spinner /> : null}
        {!loading ? (
          <>
            <Alerts type="ma" />
            <FiltersControls
              perPageSelected={perPage}
              perPageOnChange={(payload) => setPerPage(payload.value)}
            />
            <BoxList
              type="course"
              items={items}
              alert={t('global.noResultsCourses')}
              renderActionsFull
            />
            <Pagination
              styled
              currentPage={page}
              totalPages={pages}
              onChange={(payload) => {
                setPage(payload);
                loadList();
              }}
            />
          </>
        ) : null}
      </Container>
    </PageContent>
  );
};

Canceled.propTypes = {
  loading: PropTypes.bool,
  loadList: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  list: globalPropTypes.ListPropsTypes.isRequired,
};

Canceled.defaultProps = {
  loading: false,
};

const mapStateToProps = ({
  loading,
  ma: {
    courses: { canceled: list },
  },
}) => ({
  loading: isLoading(loading, 'LOAD_MA_COURSES_CANCELED'),
  list,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCoursesCreator('canceled')),
  setPage: (payload) => dispatch(setMaCoursesPageCreator('canceled', payload)),
  setPerPage: (payload) => dispatch(setMaCoursesPerPageCreator('canceled', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Canceled);
